export const colors = [
  { value: "white", label: "Белый" },
  { value: "black", label: "Чёрный" },
  { value: "gray", label: "Cерый" },
  { value: "silver", label: "Cеребристый" },
  { value: "red", label: "Kрасный" },
  { value: "maroon", label: "Бордовый" },
  { value: "gold", label: "Золотистый" },
  { value: "orange", label: "Оранжевый" },
  { value: "yellow", label: "Жёлтый" },
  { value: "green", label: "Зелёный" },
  { value: "light_blue", label: "Голубой" },
  { value: "blue", label: "Синий" },
  { value: "navy", label: "Темно-синий" },
  { value: "purple", label: "Баклажан" },
  { value: "beige", label: "Бежевый" },
  { value: "brown", label: "Коричневый" },
  { value: "pink", label: "Розовый" },
  { value: "teal", label: "Бирюзовый" },
  { value: "other", label: "Другой" },
];

export const colorsOptions = [
  "white",
  "black",
  "gray",
  "silver",
  "red",
  "maroon",
  "gold",
  "orange",
  "yellow",
  "green",
  "light_blue",
  "blue",
  "navy",
  "purple",
  "beige",
  "brown",
  "pink",
  "teal",
  "other",
];

export const bodyType = [
  { value: "sedan", label: "Седан" },
  { value: "suv", label: "Внедорожник" },
  { value: "hatchback", label: "Хэтчбек" },
  { value: "coupe", label: "Купе" },
  { value: "wagon", label: "Универсал" },
  { value: "convertible", label: "Кабриолет" },
  { value: "van", label: "Фургон" },
  { value: "pickup", label: "Пикап" },
  { value: "truck", label: "Грузовик" },
  { value: "other", label: "Другой" },
];

export const bodyTypeOptions = [
  "sedan",
  "suv",
  "hatchback",
  "coupe",
  "wagon",
  "convertible",
  "van",
  "pickup",
  "truck",
  "other",
];

export const fuel = [
  { value: "hybrid", label: "Гибрид" },
  { value: "gasoline", label: "Бензин" },
  { value: "gas", label: "Газ" },
  { value: "diesel", label: "Дизель" },
  { value: "electric", label: "Электрический" },
];

export const fuelTypesOptions = [
  "hybrid",
  "gasoline",
  "gas",
  "diesel",
  "electric",
];

export const driveType = [
  { value: "front_wheel_drive", label: "Передний" },
  { value: "rear_wheel_drive", label: "Задний" },
  { value: "all_wheel_drive", label: "Полный" },
  { value: "other", label: "Другой" },
];

export const driveTypeOptions = [
  "front_wheel_drive",
  "rear_wheel_drive",
  "all_wheel_drive",
  "other",
];

export const transmission = [
  { value: "automatic", label: "Автомат" },
  { value: "manual", label: "Механика" },
  { value: "semi_automatic", label: "Полуавтоматическая" },
  { value: "continuously_variable", label: "Вариатор" },
  {
    value: "dual_clutch",
    label: "Роботизированная с двойным сцеплением",
  },
  { value: "tiptronic", label: "Типтроник" },
  {
    value: "direct_shift_gearbox",
    label: "Прямой переключатель передач",
  },
];

export const transmissionOptions = [
  "automatic",
  "manual",
  "semi_automatic",
  "continuously_variable",
  "dual_clutch",
];

export const wheel = [
  { value: "left", label: "Слева" },
  { value: "right", label: "Справа" },
];

export const wheelOptions = ["left", "right"];

export const condition = [
  { value: "new", label: "Новое" },
  { value: "perfect", label: "Идеальное" },
  { value: "good", label: "Хорошее" },
  { value: "fair", label: "Удовлетворительное" },
  { value: "poor", label: "Аварийное/на ходу" },
];

export const conditionOptions = ["new", "perfect", "good", "fair", "poor"];

export const inStock = [
  { value: "in_stock", label: "В наличии" },
  { value: "to_order", label: "На заказ" },
  { value: "on_the_way", label: "В пути" },
];

export const availableOptions = ["in_stock", "to_order", "on_the_way"];

export const registrationCouyntry = [
  { value: "china", label: "Китай" },
  { value: "kyrgyzstan", label: "Кыргызстан" },
  { value: "russia", label: "Россия" },
  { value: "korea", label: "Корея" },
  { value: "not_registered", label: "Не стоит на учете" },
];

export const locationOptions = [
  "china",
  "kyrgyzstan",
  "russia",
  "korea",
  "not_registered",
];
export const currency = [
  { value: "usd", label: "USD" },
  { value: "cny", label: "CNY" },
  { value: "kgs", label: "KGS" },
  { value: "rub", label: "RUB" },
];

export const manufacturers = [
  {
    value: "china",
    label: "Китай",
  },
  {
    value: "japan",
    label: "Япония",
  },
  {
    value: "germany",
    label: "Германия",
  },
  {
    value: "south_korea",
    label: "Южная Корея",
  },
  {
    value: "russia",
    label: "Россия",
  },
  {
    value: "usa",
    label: "США",
  },
  {
    value: "taiwan",
    label: "Тайвань",
  },
  {
    value: "india",
    label: "Индия",
  },
  {
    value: "uk",
    label: "Великобритания",
  },
  {
    value: "italy",
    label: "Италия",
  },
  {
    value: "france",
    label: "Франция",
  },
  {
    value: "brazil",
    label: "Бразилия",
  },
  {
    value: "kazakhstan",
    label: "Казахстан",
  },
  {
    value: "orther",
    label: "Другое",
  },
];

export const manufacturersOptions = [
  "china",
  "japan",
  "germany",
  "south_korea",
  "russia",
  "usa",
  "taiwan",
  "india",
  "uk",
  "italy",
  "france",
  "brazil",
  "kazakhstan",
  "other",
];

export const rangeFuelVolume = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) =>
    (start + i * step).toFixed(1)
  );

export const rangeYear = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
